import React from 'react';

/**
 * LabelChip - Display a single label with color
 * @param {Object} label - Label object {id, name, color}
 * @param {Function} onRemove - Optional callback when X is clicked
 * @param {Function} onClick - Optional callback when chip is clicked (for filtering)
 * @param {boolean} removable - Show remove button
 */
export function LabelChip({ label, onRemove, onClick, removable = false }) {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick?.(label);
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    onRemove?.(label);
  };

  return (
    <span
      className={`label-chip ${onClick ? 'label-chip--clickable' : ''}`}
      style={{ 
        backgroundColor: label.color + '20', // 20 = 12.5% opacity
        borderColor: label.color,
        color: label.color
      }}
      onClick={onClick ? handleClick : undefined}
      title={onClick ? `Filter by ${label.name}` : label.name}
    >
      <span className="label-chip__name">{label.name}</span>
      {removable && (
        <button
          className="label-chip__remove"
          onClick={handleRemove}
          title={`Remove ${label.name}`}
        >
          ×
        </button>
      )}
    </span>
  );
}

export default LabelChip;
